export const objectToQueryString = (params) => {
    return Object.entries(params)
        .filter(([, value]) => value !== null && (Array.isArray(value) ? value.length > 0 : value))
        .flatMap(([key, value]) => {
            if (Array.isArray(value)) {
                return value.map(item => `${encodeURIComponent(key)}=${encodeURIComponent(item)}`);
            } else {
                return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
            }
        })
        .join('&');
};
